import { ACTIVE_TAB, LOADER_STATUS, FILE_DATA, FILTER_DATA_JW, SET_ENTITY_LIST, PROFILE_DATA, JWT_GSTIN_DATA, ORG_CHALLAN_DATA, NEW_CHALLAN_DATA, INVOICE_DATA, DEFAULT_ENTITY, DEFAULT_GSTIN, DEFAULT_FREQUENCY, DEFAULT_SELECT_PERIOD } from "./constants";

const initialState = {
  loaderStatus: false,
  activeTab: 1,
  fileData: [],
  filterDataJW: [],
  entityList: [],
  gstinList: [],
  entityMasterList: [],
  profileData: [],
  jwt_GSTIN_List: [],
  orgChallanList: [],
  newChallanList: [],
  invoiceList: [],
  defaultEntity:"",
  defaultGSTIN:"",
  defaultFrequency:"",
  defaultSelectPeriod:{} 
}

const itc04ViewReducer = (state = initialState, action) => {
  switch (action.type) {
    case DEFAULT_ENTITY:{
      return {
        ...state,
        defaultEntity: action.data
      }
    } 
    case DEFAULT_GSTIN:{
      return {
        ...state,
        defaultGSTIN: action.data
      }
    }
    case DEFAULT_FREQUENCY:{
      return {
        ...state,
        defaultFrequency: action.data
      }
    }
    case DEFAULT_SELECT_PERIOD:{
      return {
        ...state,
        defaultSelectPeriod: action.data
      }
    }

    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus
      }
    case FILE_DATA:
      return {
        ...state,
        fileData: action.fileData
      }
    case FILTER_DATA_JW:
      return {
        ...state,
        filterDataJW: action.filterDataJW
      }
    case ACTIVE_TAB:
      return {
        ...state,
        activeTab: action.activeTab
      }
    case SET_ENTITY_LIST:
      return {
        ...state,
        entityMasterList: action.payload
      }
    case PROFILE_DATA:
      return {
        ...state,
        profileData: action.profileData
      }
      case JWT_GSTIN_DATA:{
        console.log("action.datajwt_GSTIN_List",action.data)
        return {
          ...state,
          jwt_GSTIN_List: action.data
        }
      }
      case ORG_CHALLAN_DATA:{
        return {
          ...state,
          orgChallanList: action.data
        }
      }
      case NEW_CHALLAN_DATA:{
        return {
          ...state,
          newChallanList: action.data
        }
      }
      case INVOICE_DATA:{
        return {
          ...state,
          invoiceList: action.data
        }
      }
      
    default: return state
  }
}

export default itc04ViewReducer;